function setAssetlibSlideVisibility(tourData, assetData, visibleInSlides) {
    for (let key in assetData.assets.objects) {
        const objectData = assetData.assets.objects[key];
        const parentData = assetData.assets.objects[objectData.parent];
        const isRoot = !parentData || !parentData.parent;

        if (isRoot) {
            for (let slideData of tourData.slides) {
                slideData.animation[key].visible = false;
            }

            let isVisible = true;
            if (assetData.slide) {
                const slideData = assetData.slide.animation[key];
                isVisible = slideData.visible !== false && slideData.deleted !== true;
            }

            for (let [index, slideData] of tourData.slides.entries()) {
                let visibleInSlide = visibleInSlides[index];
                let animData = slideData.animation[key];
                animData.visible = isVisible && visibleInSlide;
            }
        }
    }
}

export default setAssetlibSlideVisibility;
